"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = exports.queryClient = void 0;
__exportStar(require("./campaigns"), exports);
__exportStar(require("./client-cards"), exports);
__exportStar(require("./clients"), exports);
__exportStar(require("./users"), exports);
__exportStar(require("./types"), exports);
__exportStar(require("./merchants"), exports);
__exportStar(require("./reports"), exports);
var queryClient_1 = require("./queryClient");
Object.defineProperty(exports, "queryClient", { enumerable: true, get: function () { return __importDefault(queryClient_1).default; } });
var api_1 = require("./api");
Object.defineProperty(exports, "api", { enumerable: true, get: function () { return __importDefault(api_1).default; } });
